import './about.css';
import './feedback.css';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronRight } from "@fortawesome/free-solid-svg-icons";


import mission from '../imagesHome/mission.png';
import approach from '../imagesHome/approach.png';
import cursant from '../imagesHome/cursant.png';
import quiz from '../imagesHome/quiz.png';
import education from '../imagesHome/education.png';
import improvements from '../imagesHome/improvements.png';



export const Feedback = () => {
  return (
  

    <div className="general-container-footer-info-ab">
      <div className="info-footer-container-ab">

   


        <div className='tittle-ab-top'>
            <h4>Cum te putem ajuta?</h4>
        </div>

        

       <section className='section-about-2'>
  <div className='part-left-feedback'>

 <h4>Descrie problema</h4>
  <p>
    Povesteste-ne pe scurt ce nu a functionat cum te asteptai.
    <br/>
    Cu cat avem mai multe detalii, cu atat putem ajuta mai repede.
    </p>
  </div>
  <div className='part-right-feedback'>
  <div className="feedback-form">
  <form>
    <label>
      Adresa de e-mail *
      <input type="email" name="email" required placeholder="ex: exemplu@email.com" />
    </label>

    <label>
      Subiect *
      <input type="text" name="subject" required />
    </label>

    <label>
      Descriere *
      <textarea name="description" required placeholder="Descrie cat mai clar problema..."></textarea>
    </label>

    <label>
      Tipul problemei *
      <select required>
        <option value="">Selecteaza unul...</option>
<option value="raporteaza-abuz">Raporteaza abuz</option>
<option value="acces-cont">Nu-mi pot accesa contul</option>
<option value="eroare">Raport de eroare</option>
<option value="achizitie">Problema cu achizitia sau abonamentul</option>
<option value="alta-eroare">Alta eroare</option>
<option value="stergere-cont">Solicitare de stergere a contului</option>

      </select>
    </label>

    <label className="file-upload">
      Atasamente
      <div className="upload-box">
        <span>
          <strong>Adauga fisier</strong> sau trage fisierele aici
        </span>
        <input type="file" multiple />
      </div>
    </label>

    <button type="submit">Trimite</button>
  </form>
</div>

  
</div>

</section>


       














             <div className='line-about'></div>

       








     

      </div>
    </div>
   
  )
}
